import { z } from 'zod';

export const EVIDENCE_MAX_BYTES = 20 * 1024 * 1024;
export const EVIDENCE_CONTENT_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp', 'text/plain'] as const;
export const EVIDENCE_FILE_ACCEPT = '.pdf,.jpg,.jpeg,.png,.webp,.txt';
export const evidenceFileSchema = z.object({
  filename: z.string().min(1, 'Enter a filename').max(200, 'Filenames must be at most 200 characters'),
  contentType: z.enum(EVIDENCE_CONTENT_TYPES, { error: 'Use a PDF, JPG, PNG, WebP or text file' }),
  size: z.number().int().positive('The file is empty').max(EVIDENCE_MAX_BYTES, 'Files must be 20 MB or smaller'),
});
export const evidenceUploadSchema = evidenceFileSchema.extend({ entityType: z.literal('corporate-action'), entityId: z.string().uuid() });
export const evidenceDispositionSchema = z.enum(['attachment', 'inline']).default('attachment');

const extensions: Record<string, typeof EVIDENCE_CONTENT_TYPES[number]> = {
  pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', txt: 'text/plain',
};
export function evidenceFileMetadata(file: { name: string; type: string; size: number }) {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
  return evidenceFileSchema.safeParse({ filename: file.name, contentType: file.type || extensions[extension] || '', size: file.size });
}
